var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftFailedIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 355,
    viewBox: "0 0 375 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 355C291.053 355 375 343.139 375 328.508C375 313.878 291.053 302.017 187.5 302.017C83.9466 302.017 0 313.878 0 328.508C0 343.139 83.9466 355 187.5 355Z",
    fill: "#F5F5F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.3691,
    width: 203.207,
    height: 335.357,
    rx: 14,
    fill: "#18BC46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 95.2227,
    y: 6.86426,
    width: 187.5,
    height: 321.629,
    rx: 11,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 150.197,
    y: 0.000488281,
    width: 77.5524,
    height: 18.6309,
    rx: 6,
    fill: "#18BC46"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 167.867,
    y: 8.8252,
    width: 53.9921,
    height: 5.88345,
    rx: 2.94173,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 157.07,
    y: 8.8252,
    width: 5.89005,
    height: 5.88345,
    rx: 2.94173,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 217.688,
    width: 106.021,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 228.475,
    width: 41.2304,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 113.875,
    y: 214.746,
    width: 36.322,
    height: 22.5532,
    rx: 6,
    fill: "#DFE2ED"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 252.008,
    width: 106.021,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 262.795,
    width: 41.2304,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 113.875,
    y: 249.066,
    width: 36.322,
    height: 22.5532,
    rx: 6,
    fill: "#DFE2ED"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 286.328,
    width: 106.021,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 160.012,
    y: 297.115,
    width: 41.2304,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 113.875,
    y: 283.387,
    width: 36.322,
    height: 22.5532,
    rx: 6,
    fill: "#DFE2ED"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 110.93,
    y: 37.2617,
    width: 119.764,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 239.529,
    y: 37.2617,
    width: 27.4869,
    height: 5.88345,
    rx: 2.94173,
    fill: "#DFE2ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.175 161.252C213.573 161.252 233.351 141.496 233.351 117.126C233.351 92.7558 213.573 73 189.175 73C164.778 73 145 92.7558 145 117.126C145 141.496 164.778 161.252 189.175 161.252Z",
    fill: "white",
    stroke: "#FF8845",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeDasharray: "7 7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.894 124.836L184.367 94H194.633L193.106 124.836H185.894ZM189.5 139C187.911 139 186.587 138.478 185.528 137.433C184.509 136.389 184 135.052 184 133.422C184 131.792 184.509 130.455 185.528 129.411C186.587 128.325 187.911 127.781 189.5 127.781C191.13 127.781 192.454 128.325 193.472 129.411C194.491 130.455 195 131.792 195 133.422C195 135.093 194.491 136.451 193.472 137.496C192.454 138.499 191.13 139 189.5 139Z",
    fill: "#FF8845"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftFailedIllustration);
export default __webpack_public_path__ + "static/media/GiftFailedIllustration.ec1f82b34e9de04b0beb7df1dd778a0d.svg";
export { ForwardRef as ReactComponent };